export const getIsUploading = ({ csv }) => csv.upload.isLoading;

export const getUploadingErrorMessage = ({ csv }) => csv.upload.error;

export const getIsShowing = ({ csv }) => csv.show.isLoading;

export const getIsSaving = ({ csv }) => csv.save.isLoading;

export const getCurrentCSV = ({ csv }) => csv.show.data;
